export default __webpack_public_path__ + "static/Hepatofelin-desktop-e00f5fcb6a588ca98256521356410e0b.jpg";